if (!customElements.get('ticker-section')) {
  class TickerSection extends HTMLElement {
    constructor() {
      super();
      window.addEventListener('MutationObserver', this.update.bind(this), {once: true});
    }

    connectedCallback() {
      this.content = this.querySelector('.ticker__content');
      this.speed = parseInt(this.dataset.speed);

      this.classList.remove('hidden');
      this.update();
    }

    update() {
      this.classList.remove('animate');
      this.getSizes();
      this.cloning();
      this.setSpeed();
      this.classList.add('animate');
    }

    getSizes() {
      this.width = this.clientWidth;
      this.contentWidth = 0;

      this.content.childNodes.forEach(element => {
        if(!element.clientWidth) return;
        this.contentWidth = this.contentWidth + element.clientWidth;
      });
    }

    setSpeed() {
      this.style.setProperty('--scroll-duration', `${this.contentWidth / (60 + 30 / 3 * this.speed)}s`);
    }

    cloning() {
      const clonningIndex = parseInt(this.width / this.contentWidth) + 1;
      const clones = this.querySelectorAll('.ticker__content--clone');
      
      if(clones.length >= clonningIndex) return;
      
      for(let i = 0; i < clonningIndex; i++) {
        let clonedContent = this.content.cloneNode(true);

        clonedContent.classList.add('ticker__content--clone');
        this.insertBefore(clonedContent, this.content.nextSibling);
      }
    }
  }

  customElements.define('ticker-section', TickerSection);
}